import { useTranslation } from "react-i18next";
import { Text } from "theme-ui";
import type { JSX } from "react";
import { Layout } from "@dsaui/components";
import { useQueryParams } from "utils/hooks";

const ErrorPage = (): JSX.Element => {
  const { i18n, t } = useTranslation();
  const query = useQueryParams();

  let errorCode = query.get("code") ?? "fallback";
  const keyExists = i18n.exists(`errors.${errorCode}`);

  if (!keyExists) {
    console.warn(`Missing translation for key: ${errorCode} - using fallback...`);
    errorCode = "fallback";
  }

  const page = (
    <Layout title={t("pages.error")}>
      <Text as="p" variant="body">
        {t(`errors.${errorCode}`)}
      </Text>
    </Layout>
  );
  return page;
};

export default ErrorPage;
